import React from 'react'
import {OrderCard} from '../../shared'
import {deliveryTypes} from 'app/constant'
import CustomButton from '../../edit/customer/CustomButton'
import capitalize from 'lodash/capitalize'
import LocationDisplay from './LocationDisplay'

interface Props {
  orderDeliveryMethod: any
  orderPickupLocation?: any
  onClick?: () => void
  isShowEdit?: boolean
}

export const OrderDeliveryMethod: React.FC<Props> = ({
  orderDeliveryMethod,
  orderPickupLocation,
  onClick,
  isShowEdit,
}) => {
  return (
    <OrderCard
      title='Delivery Method'
      className='py-6'
      toolbar={onClick && isShowEdit && <CustomButton onClick={onClick}> Edit</CustomButton>}
    >
      <div className='d-flex flex-column'>
        <span className='fs-5 fw-bolder pb-2'>{capitalize(orderDeliveryMethod)}</span>
        {orderDeliveryMethod === deliveryTypes.pickup &&
          orderPickupLocation?.fulfillmentLocation && (
            <LocationDisplay location={orderPickupLocation?.fulfillmentLocation} />
          )}
      </div>
    </OrderCard>
  )
}

export default OrderDeliveryMethod
